module.exports = __webpack_public_path__ + "img/1280.f320aacb.svg";